var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"not-found-container"}},[_c('div',[_c('h2',[_vm._v("Page not found")]),_c('p',[_vm._v(" This page could not be found "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go back to home")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }